<template>
  <div>
    <div class="row">
			<div class="col-md-12 centered">
				<p>
					<!--Занятия проходят во Дворце Учащейся молодежи, расположенном по адресу:
          ул. Малая Конюшенная д.1/3
		  -->
				</p>
				<p>
					<a href="tel:+78129161500" >Телефон: +7 (812) 916-15-00</a>
				</p><br>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
			
			<iframe id="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1998.9855516461898!2d30.36271511155701!3d59.932381918016056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469631a3530d71b9%3A0xf49c938b06567eeb!2z0JvQuNCz0L7QstGB0LrQuNC5INC_0YAuLCAxMCAvIDExOCwg0KHQsNC90LrRgi3Qn9C10YLQtdGA0LHRg9GA0LMsIDE5MTAzNg!5e0!3m2!1sru!2sru!4v1725462475530!5m2!1sru!2sru" style="border:0;" :height="height" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			
			</div>
		</div>
  </div>
</template>

<script>
export default {
  // name: 'Contacts'
  props: {
    height: {
      type: Number,
      default: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #map {
    width: 100%;
  }
  a, a:hover {
    color: black;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// Contacts.vue?6fd446f0